import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dictionaries: {},
  languages: [],
  currentLanguage: "en-US",
};

const i18nSlice = createSlice({
  name: "i18n",

  initialState,

  reducers: {
    setDictionaries: (state, action) => {
      state.dictionaries = action.payload;
    },

    setLanguages: (state, action) => {
      state.languages = action.payload;
    },

    setCurrentLanguage: (state, action) => {
      state.currentLanguage = action.payload;
    },
  },
});

export const { setDictionaries, setLanguages, setCurrentLanguage } =
  i18nSlice.actions;

export default i18nSlice.reducer;
